import styled from 'styled-components';
import { COLOR_CV_6 } from 'constants/colors';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AvatarContainer = styled.div`
  margin-bottom: 8px;
`;

export const LogoutButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_CV_6}
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
